import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, X } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/admin/adminLabels";

const SEVERITY_DOT = {
  info: "bg-turquoise",
  warning: "bg-gold",
  danger: "bg-red-500",
};

export default function NotificationsBell({ onSelectLead }) {
  const [data, setData] = useState({ items: [], unread_count: 0 });
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const r = await api.get("/admin/notifications");
      setData(r.data);
    } catch (e) { /* noop */ }
  };

  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!open) return;
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [open]);

  const markAllRead = async () => {
    await api.post("/admin/notifications/mark-read", {});
    load();
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="notifications-bell"
          onClick={load}
          className="relative h-9 w-9 rounded-md border border-[#E2E8F0] flex items-center justify-center hover:bg-sand"
        >
          <Bell className="h-4 w-4 text-navy" />
          {data.unread_count > 0 && (
            <span
              data-testid="notif-badge"
              className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-gold text-navy text-[10px] font-bold flex items-center justify-center"
            >
              {data.unread_count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[380px] p-0">
        <div className="flex items-center justify-between p-3 border-b border-[#E2E8F0]">
          <p className="font-medium text-navy text-sm">Notifiche</p>
          <div className="flex items-center gap-2">
            <button
              data-testid="notif-mark-read"
              onClick={markAllRead}
              className="text-xs text-ink hover:text-navy"
            >Segna tutte come lette</button>
            <button onClick={() => setOpen(false)} className="text-ink hover:text-navy"><X className="h-3.5 w-3.5" /></button>
          </div>
        </div>
        <div className="max-h-[420px] overflow-y-auto">
          {data.items.length === 0 && (
            <p className="p-6 text-center text-sm text-ink">Nessuna notifica al momento.</p>
          )}
          {data.items.map((n, i) => (
            <button
              key={i}
              data-testid={`notif-item-${i}`}
              onClick={() => { setOpen(false); onSelectLead?.(n.lead_id); }}
              className="w-full text-left px-3 py-3 border-b border-[#E2E8F0] last:border-0 hover:bg-sand/50 flex gap-3"
            >
              <span className={`mt-1.5 h-2 w-2 rounded-full ${SEVERITY_DOT[n.severity] || "bg-turquoise"}`} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-navy truncate">{n.title}</p>
                <p className="text-xs text-ink truncate">{n.body}</p>
                <p className="text-[10px] uppercase tracking-wider text-ink mt-1">{fmtDate(n.created_at)}</p>
              </div>
            </button>
          ))}
        </div>
        <div className="p-2 border-t border-[#E2E8F0]">
          <Button variant="outline" onClick={load} className="w-full h-8 text-xs">Aggiorna</Button>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
